import React from 'react';
import { motion } from 'framer-motion';
export function CancellationPolicyPage() {
  return <main className="flex-1 bg-background" data-id="element-147">
      {/* Hero Section */}
      <section className="relative pt-16 pb-12 lg:pt-24 lg:pb-16 bg-gradient-to-br from-primary/5 to-accent/5" data-id="element-148">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-149">
          <motion.h1 initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-bold text-slate-dark mb-6" data-id="element-150">
            Cancellation Policy
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed" data-id="element-151">
            Bluecore offers a fair cancellation policy to ensure customer
            satisfaction.
          </motion.p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white" data-id="element-152">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-12" data-id="element-154">
            <div data-id="element-155">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-156">
                14-Day Cancellation Window
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed mb-4" data-id="element-157">
                We offer a full refund for cancellations made within 14 days of
                your subscription start date, provided that no ebooks have been
                accessed or read during this period.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-158">
                To request a cancellation within this window, please email us at{' '}
                <a href="mailto:manishhoran123@gmail.com" className="text-primary hover:underline" data-id="element-159">
                  manishhoran123@gmail.com
                </a>{' '}
                with your subscription details and order reference number.
              </p>
            </div>

            <div data-id="element-160">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-161">
                After 14 Days
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed mb-4" data-id="element-162">
                For cancellations requested after the initial 14-day period,
                refunds may not be available depending on your usage of the
                service.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-163">
                If you choose to cancel your subscription after 14 days, your
                access to the Bluecore library will continue until the end of
                your current billing period. Your subscription will not renew
                for the following year.
              </p>
            </div>

            <div data-id="element-164">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-165">
                Processing Time
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-166">
                Approved refunds are typically processed within 5-10 working
                days. The funds will be returned to your original payment
                method.
              </p>
            </div>

            <div className="bg-slate-50 p-6 rounded-xl border border-slate-100" data-id="element-167">
              <h2 className="text-xl font-bold text-slate-dark mb-2" data-id="element-168">
                Questions?
              </h2>
              <p className="text-slate-600" data-id="element-169">
                If you have any questions about our cancellation policy, please
                contact our support team at{' '}
                <a href="mailto:manishhoran123@gmail.com" className="text-primary hover:underline" data-id="element-170">
                  manishhoran123@gmail.com
                </a>
                .
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </main>;
}